const filterListModalFilterExpiredServices = {
  filter: 'FILTROS',
  clear: 'borrar todos los filtros'
};

export default filterListModalFilterExpiredServices;
